import React from 'react';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import BaseTable from 'components/tables/BaseTable';
import {useListCompanyAccountsQuery} from "apis/companiesApi";
import {Dropdown} from "primereact/dropdown";
import { FilterMatchMode } from 'primereact/api';
import roles from "data/company-roles.json"
import {useUserProfileQuery} from "../../apis/authenticationApi";

const CompanyUsersTable = () => {
    const navigate = useNavigate();
    const {data, isFetching} = useListCompanyAccountsQuery();
    const {data: userProfile} = useUserProfileQuery();
    const canEdit = userProfile?.company?.role === "CompanyOwner";

    const newCompanyUser = canEdit? ()  => edit("new") : undefined;
    
    const edit = (id) => {
        navigate(`/company-admin/users/edit/${id}`);
    }

    const actionTemplate = (rowData) => {
        return (
            <Button type="button" icon={"pi " +  (canEdit? "pi-pencil" : "pi-eye")} onClick={() => edit(rowData.id)} />
        );
    }

    const statuses = [
        'deactivated', 'invited', 'registered'
    ];

    const statusRowFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Status" className="p-column-filter dropdown-column" showClear />;
    }

    const roleRowFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={roles} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Role" className="p-column-filter dropdown-column" showClear />;
    }

    const roleBodyTemplate = (rowData) => {
        return (
            <>
                {roles.find(role => role.value === rowData.role)?.label}
            </>
        );
    }

    return (
        <>
            <BaseTable
                createNew={newCompanyUser}
                isLoading={isFetching}
                emptyMessage="No company users found."
                globalFilterFields={['firstName', 'lastName', 'email', 'role', 'status']}
                fieldFilters={{
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    'firstName': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                    'lastName': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                    'email': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                    'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                    'role': { value: null, matchMode: FilterMatchMode.EQUALS }
                }}
                dataList={data}>
                <Column className="name-column" field="firstName" header="First Name"  filter filterPlaceholder="First name" />
                <Column className="name-column" field="lastName" header="Last Name"  filter filterPlaceholder="Last name" />
                <Column field="email" header="Email" filter filterPlaceholder="Search by email" />
                <Column className="dropdown-column" field="role" header="Role" filter filterElement={roleRowFilterTemplate} body={roleBodyTemplate} />
                <Column className="dropdown-column" field="status" header="Status" filter filterElement={statusRowFilterTemplate} />
                <Column className="action-column" headerClassName="centered-header" bodyClassName="p-text-center" header="Actions" body={actionTemplate}></Column>
            </BaseTable>
        </>
    )
}

export default CompanyUsersTable;